export default __webpack_public_path__ + "static/media/VendaDireta.2c942ede.svg";